import Menu from './pages/Menu';
import './App.css';

export default function App() {
  return <Menu />;
}
